/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:eaabc2d1-67cc-44cd-a027-84eb6543758d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_1YOLHOc9S",
    "aws_user_pools_web_client_id": "444f8vdtujr54b2trg46f3771p",
    "oauth": {
        "domain": "stellmichein8ffb4201-8ffb4201-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://stellmichein.de/login/success/,http://localhost:3000/login/success/,https://stellmichein.de/login/success/",
        "redirectSignOut": "https://stellmichein.de/,http://localhost:3000/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://4fflqqzxzzhzzmfl2k3xdzv5qq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6bnf45lp2bhcjodiuilr4mlj3y",
    "aws_user_files_s3_bucket": "stellmicheinbilderbucket150553-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
